export const QUERY_KEY_USERS = "users";
export const QUERY_KEY_ALL_USERS = "allUsers";
export const QUERY_KEY_CONTACTS = "contacts";
export const QUERY_KEY_CONTACT_LIST = "contactList";
export const QUERY_KEY_GROUPS = "groups";
export const QUERY_KEY_PARTICIPANTS = "participants";
export const QUERY_KEY_PARTICIPANTS_FOR_GROUPS_BY_SEARCH = "participantsForGroupsBySearch";
